import React, { useState } from "react";
import ExcelJS from "exceljs";
import { Button, Modal, Tag } from "antd";
import { DownloadOutlined, FileExcelOutlined } from "@ant-design/icons";
import { getExportableColumns, extractValueFromColumn } from "./Colonnes";
import "./DataExport.css";
import { formatDate } from "../../Components/Common/FormatDate/FormatDate";

const DataExport = ({
  columns = [],
  data = [],
  title = "Extraction de données",
  fileName = "export.xlsx",
  buttonLabel = "Exporter Excel",
  buttonType = "primary",
  buttonClass = "",
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleExport = async () => {
    setIsModalVisible(false);
    if (!data.length) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Données exportées");

    const exportColumns = getExportableColumns(columns);

    // ===== TITRE =====
    worksheet.mergeCells(1, 1, 1, exportColumns.length);
    const titleCell = worksheet.getCell(1, 1);
    titleCell.value = title;
    titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF1F5357" },
    };

    // Ligne vide pour espacer le titre
    worksheet.addRow([]);

    // ===== HEADERS =====
    worksheet.addRow(exportColumns.map(col => col.Header));
    const headerRow = worksheet.getRow(3); // ligne 3 après titre + vide
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };
    headerRow.eachCell(cell => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9D9D9" } };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // ===== DATA =====
    data.forEach(row => {
      worksheet.addRow(
        exportColumns.map(col => {
          const raw = extractValueFromColumn(col, row);
          if (col.accessor === "createdAt" || col.Header.toLowerCase().includes("date")) {
            return raw ? formatDate(raw, true) : "-";
          }
          return raw;
        })
      );
    });

    const MAX_WIDTH = 30;
    worksheet.columns.forEach(column => {
    let maxLength = 10;
    column.eachCell({ includeEmpty: true }, cell => {
        const cellLength = cell.value ? cell.value.toString().length : 0;
        maxLength = Math.max(maxLength, cellLength);
    });
    column.width = Math.min(maxLength + 2, MAX_WIDTH);
    });


    // ===== EXPORT =====
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  return (
    <>
      <Button
        type={buttonType}
        icon={<DownloadOutlined />}
        onClick={() => setIsModalVisible(true)}
        className={`exp-dataexport-button ${buttonClass}`}
        disabled={!data.length}
      >
        {buttonLabel}
      </Button>

      <Modal
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleExport}
        okText="Oui, exporter"
        cancelText="Annuler"
        title={
          <div className="exp-modal-title">
            <FileExcelOutlined className="exp-icon" />
            Confirmation d'export
          </div>
        }
        centered
        bodyStyle={{ padding: 0 }}
        okButtonProps={{ className: "exp-modal-ok-button" }}
        cancelButtonProps={{ className: "exp-modal-cancel-button" }}
      >
        <div className="exp-modal-body">
          <p className="exp-modal-text">
            Vous êtes sur le point d’exporter <Tag color="cyan">{data.length}</Tag> lignes.
          </p>
          <p className="exp-modal-subtext">
            Assurez-vous que vos filtres et tris sont corrects avant de procéder.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default DataExport;
